import { useEffect } from "react";

const SITE_NAME = "Sarah Siqueira | Full Stack WordPress Developer";

export function usePageTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle
      ? `${pageTitle} | ${SITE_NAME}`
      : SITE_NAME;
  }, [pageTitle]);
}